<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-non-bodymatter element-container-single element-type-none element-with-heading" id="uncategorized">
<div class="heading heading-with-title heading-without-image" id="uncategorized-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Book Description</h1>
</div>
</div>
</div>
</div>
<div class="text" id="uncategorized-text">
<p class="first first-in-chapter first-full-width">Transient. Ethereal. Delicate.</p>
<p class="subsq">Insignificant.</p>
<p class="subsq">Mere insects …</p>
<p class="subsq">Like all the human beings trapped aboard a vast starship on a generations-long journey to a new home.</p>
<p class="subsq">The Mayflower is run by an immortal captain who views himself as a god.</p>
<p class="subsq">Gerard Metaclura was just a normal man until a terrible accident left him near dead, his body destroyed. But his brain was installed as the sentient command core of the generation ship.</p>
<p class="subsq">At first Gerard was confused by what had happened to him. Then angry. Then bored.</p>
<p class="subsq">Now he is the ship, controlling everything on board … including 25,000 helpless human passengers.</p>
<p class="subsq">These mayflies …</p>
<p class="subsq">Transient. Ethereal. Delicate.</p>
<p class="subsq">But maybe they’re not willing to be so helpless and insignificant after all.…</p>
<p class="subsq"><b>Mayflies</b></p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bookdescription.vue?f9d58f72